interface WarningIconProps {
	/** The tooltip, one message per line */
	text: string,
	/** Red when the message stops the declaratie from being generated, orange when it is informational */
	blocking: boolean,
}

/**
 *  Exclamation mark next to a verantwoording that has a tip, so it is visible
 *  without hovering every row. The tip itself is the native tooltip.
 */
export default function WarningIcon({ text, blocking }: WarningIconProps) {
	return (
		<span
			className={blocking ? 'error-color' : 'warning-color'}
			role='img'
			aria-label={text}
			title={text}
			tabIndex={0}
			style={{
				width: '1.1rem',
				height: '1.1rem',
				marginLeft: '0.4rem',
				// the checkbox next to it sits on the baseline: this centres the icon on it
				verticalAlign: '0.45rem',
			}}
		>
			{/* SVG instead of a text "!": the glyph position inside the circle then no longer depends on the font */}
			<svg viewBox='0 0 24 24' width='100%' height='100%' fill='none' stroke='currentColor' strokeLinecap='round' aria-hidden='true' style={{ display: 'block' }}>
				<circle cx='12' cy='12' r='10.5' strokeWidth='2' />
				<line x1='12' y1='6.5' x2='12' y2='13.5' strokeWidth='2.4' />
				<circle cx='12' cy='17.4' r='0.6' strokeWidth='2.4' />
			</svg>
		</span>
	);
}
